/** 职位管理路由 */
export default {
    name: 'jobmanage',
    path: 'jobmanage',
    meta: {
        title: '职位管理'
    },
    component: ()=>import('@/pages/jobmanage/jobmanage.vue'),
    children: []
}